<template>
  <div class="page-wrap">
    <van-cell title="转盘抽奖"
              is-link
              to="/turntable" />
    <van-cell title="九宫格抽奖"
              is-link
              to="/nineJiuge" />
    <van-cell title="刮刮卡抽奖"
              is-link
              to="/scratchCard" />
    <van-cell title="翻牌中大奖"
              is-link
              to="/cardDraw" />
    <van-cell title="爱奇艺内购"
              is-link
              to="/iqiyiPurchase" />
    <van-cell title="云南vivo新人福利领取"
              is-link
              to="/newUserWelfare" />
    <van-cell title="公众号无法连接小程序"
              is-link
              to="/linkFailed" />
 <van-cell title="wms导购生成邀请码"
              is-link
              to="/wmsLogin" />
 <van-cell title="抖音短剧兜底页"
              is-link
              to="/ttBackPage" />
  </div>
</template>

<script>
export default {
  name: "luckDrawIndex",
  data () {
    return {

    };
  },
  created () {
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit("set_token", this.$route.query.token);
    }
  },
  mounted () {

  },
  methods: {
    //获取当前用户的抽奖信息
    getInfo () {

    }
  },
};
</script>

<style scoped lang="scss">
</style>